import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconsModule } from "@mk/med-icons";

import { MedNotificationContainerComponent } from "./med-notification-container.component";
import { MedBtnModule } from "../../med-btn/med-btn.module";

@NgModule({
  declarations: [
    MedNotificationContainerComponent,
  ],
  imports: [
    CommonModule,
    MedIconsModule,
    MedBtnModule,
  ],
  exports: [
    MedNotificationContainerComponent,
  ],
})
export class MedNotificationContainerModule { }
